import { makeRequest, SADUKA_TRANSPORT_PREFIX } from '../utils/apiUtils';

export const ADV_TRAFFIC_TYPE_SET_FORM = 'trafficTypes/ADV_TRAFFIC_TYPE_SET_FORM';

export const GET_TRAFFIC_TYPES = 'trafficTypes/GET_TRAFFIC_TYPES';
export const GET_TRAFFIC_TYPES_SUCCESS = 'trafficTypes/GET_TRAFFIC_TYPES_SUCCESS';
export const GET_TRAFFIC_TYPES_FAIL = 'trafficTypes/GET_TRAFFIC_TYPES_FAIL';

export const GET_TRAFFIC_TYPES_ADV = 'trafficTypes/GET_TRAFFIC_TYPES_ADV';
export const GET_TRAFFIC_TYPES_ADV_SUCCESS = 'trafficTypes/GET_TRAFFIC_TYPES_ADV_SUCCESS';
export const GET_TRAFFIC_TYPES_ADV_FAIL = 'trafficTypes/GET_TRAFFIC_TYPES_ADV_FAIL';

export const SAVE_TRAFFIC_TYPES_ADV = 'trafficTypes/SAVE_TRAFFIC_TYPES_ADV';
export const SAVE_TRAFFIC_TYPES_ADV_SUCCESS = 'trafficTypes/SAVE_TRAFFIC_TYPES_ADV_SUCCESS';
export const SAVE_TRAFFIC_TYPES_ADV_FAIL = 'trafficTypes/SAVE_TRAFFIC_TYPES_ADV_FAIL';

export const SAVE_CUSTOM_TRAFFIC_TYPES_ADV = 'trafficTypes/SAVE_CUSTOM_TRAFFIC_TYPES_ADV';
export const SAVE_CUSTOM_TRAFFIC_TYPES_ADV_SUCCESS = 'trafficTypes/SAVE_CUSTOM_TRAFFIC_TYPES_ADV_SUCCESS';
export const SAVE_CUSTOM_TRAFFIC_TYPES_ADV_FAIL = 'trafficTypes/SAVE_CUSTOM_TRAFFIC_TYPES_ADV_FAIL';

export const GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY = 'trafficTypes/GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY'
export const GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY_SUCCESS = 'trafficTypes/GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY_SUCCESS'
export const GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY_FAIL = 'trafficTypes/GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY_FAIL';

export const GET_OFFER_TRAFFIC_TYPES = 'trafficTypes/GET_OFFER_TRAFFIC_TYPES';
export const GET_OFFER_TRAFFIC_TYPES_SUCCESS = 'trafficTypes/GET_OFFER_TRAFFIC_TYPES_SUCCESS';
export const GET_OFFER_TRAFFIC_TYPES_FAIL = 'trafficTypes/GET_OFFER_TRAFFIC_TYPES_FAIL';

export const GET_OFFER_CUSTOM_TRAFFIC_TYPES = 'trafficTypes/GET_OFFER_CUSTOM_TRAFFIC_TYPES';
export const GET_OFFER_CUSTOM_TRAFFIC_TYPES_SUCCESS = 'trafficTypes/GET_OFFER_CUSTOM_TRAFFIC_TYPES_SUCCESS';
export const GET_OFFER_CUSTOM_TRAFFIC_TYPES_FAIL = 'trafficTypes/GET_OFFER_CUSTOM_TRAFFIC_TYPES_FAIL';

export const GET_CATEGORY_TRAFFIC_TYPES = 'trafficTypes/GET_CATEGORY_TRAFFIC_TYPES'
export const GET_CATEGORY_TRAFFIC_TYPES_SUCCESS = 'trafficTypes/GET_CATEGORY_TRAFFIC_TYPES_SUCCESS'
export const GET_CATEGORY_TRAFFIC_TYPES_FAIL = 'trafficTypes/GET_CATEGORY_TRAFFIC_TYPES_FAIL';

export function getTrafficTypes() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/trafficTypes?show_all=true&perpage=100`, {
    types: [GET_TRAFFIC_TYPES, GET_TRAFFIC_TYPES_SUCCESS, GET_TRAFFIC_TYPES_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getTrafficTypesAdv(formId) {
  return makeRequest(`/saduka/offerTrafficTypes/formData/${formId}`, {
    types: [GET_TRAFFIC_TYPES_ADV, GET_TRAFFIC_TYPES_ADV_SUCCESS, GET_TRAFFIC_TYPES_ADV_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function saveTrafficTypesAdv(formId, traffic_types, traffic_types_custom) {
  return makeRequest(`/saduka/offerTrafficTypes/update/${formId}`, {
    types: [SAVE_TRAFFIC_TYPES_ADV, SAVE_TRAFFIC_TYPES_ADV_SUCCESS, SAVE_TRAFFIC_TYPES_ADV_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        traffic_types,
        traffic_types_custom
      })
    },
  });
}

export function advTrafficTypeSetForm(id, value, comment, name) {
  return {
    type: ADV_TRAFFIC_TYPE_SET_FORM,
    id,
    value,
    comment,
    name,
  }
}

export function getTrafficTypesByTypeAndCategory(actionTypeDirectionId, categoryId) {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/trafficTypes?perpage=100&action_type_direction_id=${encodeURIComponent(actionTypeDirectionId)}&category_id=${encodeURIComponent(categoryId)}`, {
    types: [GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY, GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY_SUCCESS, GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY_FAIL],
    options: {
      credentials: 'include'
    },
    actionTypeDirectionId,
    categoryId,
  })
}

export function getCategoryTrafficTypes(actionTypeDirectionId, categoryId) {
  return makeRequest(`/saduka/categoryTrafficTypes?action_type_direction_id=${encodeURIComponent(actionTypeDirectionId)}&category_id=${encodeURIComponent(categoryId)}`, {
    types: [GET_CATEGORY_TRAFFIC_TYPES, GET_CATEGORY_TRAFFIC_TYPES_SUCCESS, GET_CATEGORY_TRAFFIC_TYPES_FAIL],
    options: {
      credentials: 'include'
    },
    actionTypeDirectionId,
    categoryId,
  });
}

export function getOfferTrafficTypes(offerId) {
  return makeRequest(`/saduka/offerTrafficTypes?offer_id=${encodeURIComponent(offerId)}`, {
    types: [GET_OFFER_TRAFFIC_TYPES, GET_OFFER_TRAFFIC_TYPES_SUCCESS, GET_OFFER_TRAFFIC_TYPES_FAIL],
    options: {
      credentials: 'include'
    },
    offerId
  });
}

export function getOfferCustomTrafficTypes(offerId) {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/offerCustomTrafficTypes?offer_id=${encodeURIComponent(offerId)}`, {
    types: [GET_OFFER_CUSTOM_TRAFFIC_TYPES, GET_OFFER_CUSTOM_TRAFFIC_TYPES_SUCCESS, GET_OFFER_CUSTOM_TRAFFIC_TYPES_FAIL],
    options: {
      credentials: 'include'
    },
    offerId
  });
}
